/**
 * User help API – FAQ and tickets.
 * Base path: /org/userhelp
 */
import { GET, POST, PUT, DELETE } from '../apiController';

const ORG_USER_HELP = '/user/userhelp';

export const getFAQ = () => {
  return GET(`${ORG_USER_HELP}/get_faqs`);
};

export const getAllTicket = (data) => {
  return POST(`${ORG_USER_HELP}/get_all_raise_ticket`, data);
};

export const postRaiseTicketV2 = (data) => {
  return POST(`${ORG_USER_HELP}/raise_ticket_v2`, data);
};

export const updateTicket = (ticket_id, data) => {
  return PUT(`${ORG_USER_HELP}/update_ticket/${ticket_id}`, data);
};

export const deleteTicket = (ticket_id) => {
  return DELETE(`${ORG_USER_HELP}/delete_ticket/${ticket_id}`);
};
